import { useEffect, useState } from 'react';
import { Schema } from './types';

interface SchemaState {
    data: Schema | null;
    loading: boolean;
    error: string | null;
}

/** Fetches the schema graph from the admin ajax endpoint. */
export function useSchema(ajaxUrl: string): SchemaState {
    const [state, setState] = useState<SchemaState>({
        data: null,
        loading: true,
        error: null,
    });

    useEffect(() => {
        let cancelled = false;
        const sep = ajaxUrl.includes('?') ? '&' : '?';
        const url = `${ajaxUrl}${sep}ajax=1&action=Schema`;

        fetch(url, { credentials: 'same-origin' })
            .then((res) => {
                if (!res.ok) throw new Error(`HTTP ${res.status}`);
                return res.json();
            })
            .then((data: Schema & { error?: string }) => {
                if (cancelled) return;
                if (data.error) throw new Error(data.error);
                setState({ data, loading: false, error: null });
            })
            .catch((err: Error) => {
                if (cancelled) return;
                setState({ data: null, loading: false, error: err.message });
            });

        return () => {
            cancelled = true;
        };
    }, [ajaxUrl]);

    return state;
}
